import { useCallback, useRef } from 'react';
import AttachIcon from '@assets/images/attach.svg';
import close from '@assets/images/contact/close.svg?url';

interface UploadFileProps {
  className?: string;
  value?: File[];
  onChange: React.Dispatch<React.SetStateAction<File[]>>;
}

export const UploadFile = (props: UploadFileProps) => {
  const refInput = useRef<HTMLInputElement | null>(null);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newFiles = [...(e.currentTarget.files || [])];
      if (newFiles.length) {
        props.onChange([...(props.value || []), ...newFiles]);
        if (refInput.current) refInput.current.value = '';
      }
    },
    [props.onChange, props.value],
  );

  const handleRemove = useCallback(
    (index: number) => {
      props.onChange((files) => {
        const result = [...(files || [])];
        result.splice(index, 1);
        return result;
      });
    },
    [props.onChange],
  );

  return (
    <div className={props.className}>
      <ul className='flex flex-col'>
        {props.value?.map((item, i) => (
          <li
            key={i}
            className='mb-[10px] flex h-[40px] flex-nowrap items-center gap-[10px] overflow-hidden rounded-lg border border-[#78787880] bg-[#fff] pl-[10px] leading-4'
          >
            <span className='flex-1 truncate'>{item.name}</span>
            <span className='flex h-[32px] w-[32px] shrink-0 cursor-pointer items-center justify-center' onClick={() => handleRemove(i)}>
              <img src={close} />
            </span>
          </li>
        ))}
      </ul>
      <div className='relative flex h-[40px] w-[40px] cursor-pointer items-center justify-center gap-[10px] rounded-lg border border-[#78787880] bg-[#fff]'>
        <input className='absolute top-0 left-0 z-[1] h-full w-full cursor-pointer opacity-0' type='file' onChange={handleChange} ref={refInput} />
        <AttachIcon />
      </div>
    </div>
  );
};
